<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block">
        <span style="font-size: 14px;color: #2d2f33;">赊账状态：</span>
        <el-select v-model="creditStatus" style="margin: 0 10px;" class="width_200" placeholder="请选择状态" @change="chooseCreditStatus">
          <el-option label="全部" value="0"></el-option>
          <el-option label="未结清" value="1"></el-option>
          <el-option label="已结清" value="2"></el-option>
        </el-select>
        <el-input v-model.trim="inputVal" class="input_s250" placeholder="请输入顾客姓名/手机尾号" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
        </el-input>
      </div>
      <div class="commonInfo">
        <div class="content">
          <h4>赊账总人数：{{ rowCount }}</h4>
          <h4>赊账总金额：{{ sumTotalMoney }}</h4>
          <h4>已还总金额：{{ sumRefundMoney }}</h4>
          <h4>未还总金额：{{ sumUnRefundMoney }}</h4>
        </div>
      </div>
      <div class="commonTable" style="margin-bottom: 45px;">
        <el-table v-loading="loading" :data="tableData" tooltip-effect="light">
          <el-table-column prop="memberName" label="姓名" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.phone ? Lib.starPhone(scope.row.phone) : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardNo" label="会员卡号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="number" label="赊账订单（笔）" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="totalMoney" label="赊账金额（元）" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.totalMoney.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refundMoney" label="已还金额（元）" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.refundMoney.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unRefundMoney" label="未还金额（元）" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.unRefundMoney.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unRefundMoney" label="状态">
            <template slot-scope="scope">
              <span>{{ scope.row.unRefundMoney ? '未结清' : '已结清' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="270">
            <template slot-scope="scope">
              <yz-btn v-show="scope.row.unRefundMoney != 0" type="primary" @click="repayment(scope.row.memberId,scope.row.phone,scope.row.totalMoney,scope.row.refundMoney,scope.row.unRefundMoney)">还款</yz-btn>
              <yz-btn type="primary" @click="billRecord(scope.row.memberId,scope.row.phone,scope.row.totalMoney,scope.row.refundMoney,scope.row.unRefundMoney)">赊账记录</yz-btn>
              <yz-btn type="primary" @click="repayRecord(scope.row.memberId,scope.row.phone,scope.row.totalMoney,scope.row.refundMoney,scope.row.unRefundMoney)">还款记录</yz-btn>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData.length > 0" class="allFooter">
        <el-pagination background :current-page.sync="currentPage" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
        <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
      </div>
    </div>
    <gt-bill-record @billRecord="getBillRecordData"></gt-bill-record>
    <gt-repayment @repayment="getRepaymentData" @search="search"></gt-repayment>
    <gt-repayRecord @repayRecord="getRepayRecordData"></gt-repayRecord>
  </div>
</template>

<script>
import { getGzlb } from '../api';

export default {
  data() {
    return {
      inputVal: '', // 搜索值
      currentPage: 1, // 当前页
      tableData: [], // 列表数据
      pageNum: 1, // 当前页
      pageSize: 15, // 每页数据量
      pageCount: 1, // 总页数
      rowCount: '', // 数据总数
      sumTotalMoney: '', // 总赊账
      sumRefundMoney: '', // 已还款
      sumUnRefundMoney: '', // 未还款
      repaymentData: { // 还款数据
        memberId: '',
        phone: '',
        totalMoney: '',
        refundMoney: '',
        unRefundMoney: '',
        dialog: false
      },
      billRecordData: { // 赊账记录
        memberId: '',
        phone: '',
        totalMoney: '',
        refundMoney: '',
        unRefundMoney: '',
        dialog: false
      },
      repayRecordData: { // 还款记录
        memberId: '',
        phone: '',
        totalMoney: '',
        refundMoney: '',
        unRefundMoney: '',
        dialog: false
      },
      creditStatus: '0', // 赊账状态
      // 5.7
      loading: true,
    };
  },
  activated() {
    this.getListData();
  },
  methods: {
    // 搜索
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 列表渲染
    getListData() {
      const vm = this;
      const data = {
        keyWord: vm.inputVal,
        pageNum: vm.pageNum,
        pageSize: vm.pageSize,
        type: vm.creditStatus
      };
      vm.loading = true;
      getGzlb(data).then((res) => {
        vm.tableData = res.data.list ? res.data.list : [];
        vm.pageCount = res.data.rowCount;
        vm.rowCount = res.data.rowCount;
        vm.sumTotalMoney = res.data.sumMap.sumTotalMoney;
        vm.sumRefundMoney = res.data.sumMap.sumRefundMoney;
        vm.sumUnRefundMoney = res.data.sumMap.sumUnRefundMoney;
        vm.loading = false;
      });
    },
    // 赋值组件数据----还款
    getRepaymentData(list) {
      this.repaymentData = list;
    },
    // 赋值组件数据----赊账记录
    getBillRecordData(list) {
      this.billRecordData = list;
    },
    // 赋值组件数据----还款记录
    getRepayRecordData(list) {
      this.repayRecordData = list;
    },
    // 还款
    repayment(id, phone, totalMoney, refundMoney, unRefundMoney) {
      this.repaymentData.memberId = id;
      this.repaymentData.phone = phone;
      this.repaymentData.dialog = true;
      this.repaymentData.totalMoney = totalMoney;
      this.repaymentData.refundMoney = refundMoney;
      this.repaymentData.unRefundMoney = unRefundMoney;
    },
    // 赊账记录
    billRecord(id, phone, totalMoney, refundMoney, unRefundMoney) {
      this.billRecordData.memberId = id;
      this.billRecordData.phone = phone;
      this.billRecordData.dialog = true;
      this.billRecordData.totalMoney = totalMoney;
      this.billRecordData.refundMoney = refundMoney;
      this.billRecordData.unRefundMoney = unRefundMoney;
    },
    // 还款记录
    repayRecord(id, phone, totalMoney, refundMoney, unRefundMoney) {
      this.repayRecordData.memberId = id;
      this.repayRecordData.phone = phone;
      this.repayRecordData.dialog = true;
      this.repayRecordData.totalMoney = totalMoney;
      this.repayRecordData.refundMoney = refundMoney;
      this.repayRecordData.unRefundMoney = unRefundMoney;
    },
    // 选择赊账状态
    chooseCreditStatus() {
      this.getListData();
    }
  }
};
</script>
